import { INDICATOR_PRODUCT_NAME } from '@/api/rest/resources/types/IndicatorProduct';

import { useIndicatorProduct } from './useIndicatorProduct';

export const useProtectedAreasMethodology: () => {
  hasIbat: boolean;
  hasOsm: boolean;
} = () => {
  const purchasedIndicatorProducts =
    useIndicatorProduct({
      purchased: true,
      visible_for_customer: true,
    }).data ?? [];

  return {
    hasIbat: purchasedIndicatorProducts.some((ip) => INDICATOR_PRODUCT_NAME.LANDSCAPE_PROTECTED_AREAS_IBAT === ip.name),
    hasOsm: purchasedIndicatorProducts.some((ip) => INDICATOR_PRODUCT_NAME.LANDSCAPE_PROTECTED_AREAS_OSM === ip.name),
  };
};
